export default {
  inject: ['rootMenu']
}
